<div class="card-grid">
  <ng-content select="sbb-card"></ng-content>
</div>
